<template>
  <div class="coursePreviewItem fullWidth fRow jStart aCenter">
    <div class="cover"
      v-bind:style="{backgroundImage: `url('https://api.rimik.ir/${data.photo}')`}"></div>
    <div class="infos growFull fRow jBetween aCenter">
      <!-- first datas -->
      <div class="first fCol jCenter aStart w50">
        <div class="t fRow jStart aCenter">
          <i class="material-icons-round">cast_for_education</i>
          {{data.title}}</div>
        <div class="teacher fRow jStart aCenter fullWidth">
          <div class="av"
          v-bind:style="{backgroundImage: `url('https://api.rimik.ir/${data.teacherAvatar}')`}"></div>
          <div class="fCol jCenter aStart">
            <div class="teacherName">
              {{data.teacherFullName}}
            </div>
            <div class="lesson">
              {{data.lesson.title}}
            </div>
            <div class="grades">
              {{data.grade.field.title}}، {{data.grade.title}}
            </div>
          </div>
        </div>
      </div>
      <!-- second datas -->
      <div class="w50 seconds fRow jBetween aCenter wrap">
        <div class="infoItem fRow jBetween aCenter w50 price"
          title="قیمت">
          <i class="material-icons-round">sell</i>
          <span>{{commaSep(data.price)}} تومان</span>
        </div>
        <div class="infoItem fRow jBetween aCenter w50"
          title="تخفیف" v-bind:class="{discount: data.discountPercent > 0}">
          <i class="material-icons-round">percent</i>
          <span>{{data.discountPercent}}%</span>
        </div>
        <div class="infoItem fRow jBetween aCenter w50"
          title="تعداد بازدید">
          <i class="material-icons-round">visibility</i>
          <span>{{data.numberOfViews}} نمایش</span>
        </div>
        <div class="infoItem fRow jBetween aCenter w50"
          title="تعداد خرید">
          <i class="material-icons-round">credit_card</i>
          <span>{{data.numberOfPurchases}} خرید</span>
        </div>
        <div class="infoItem fRow jBetween aCenter w50"
          title="تعداد ویدیوها">
          <i class="material-icons-round">videocam</i>
          <span>{{data.numberOfVideos}} ویدئو</span>
        </div>
        <div class="infoItem fRow jBetween aCenter w50"
          title="تعداد سؤالات">
          <i class="material-icons-round">help</i>
          <span>{{data.numberOfQuestions}} پرسش</span>
        </div>
      </div>
    </div>
    <div class="actionRow fRow jCenter aCenter">
      <sw activeLabel="رایگان"
        deactiveLabel="رایگان"
        :load="swLoad"
        style="margin: 0 8px"
        :val="state"
        @click.native="updateStates('state')"/>
      <sw activeLabel="فعال"
        deactiveLabel="فعال"
        :load="swLoad"
        style="margin-left: 8px"
        :val="status"
        @click.native="updateStates('status')"/>
      <sw activeLabel="اسلایدر"
        deactiveLabel="اسلایدر"
        :load="swLoad"
        style="margin-left: 8px"
        :val="slider"
        @click.native="changeSlider"/>
      <i class="material-icons-round ac"
        title="اضافه کردن فایل و ویدئو"
        @click="goToVideoUpload">add_circle</i>
      <i class="material-icons-round ac"
        title="حذف دوره"
        @click="deleteMode = true">delete</i>
      <i class="material-icons-round ac"
        title="ویرایش دوره"
        @click="goEdit">edit</i>
    </div>
    <div class="deleteBox fRow jStart aCenter" v-if="deleteMode">
      <i class="material-icons-round del">delete</i>
      <div class="fCol deleteQuestion jCenter aStart">
        <div class="q">آیا از حذف {{data.title}} مطمئنید؟</div>
        <div class="d">این عملیات امکان بازگشت ندارد</div>
      </div>
      <div class="dbtn fRow jCenter aCenter" @click="deleteCourse(data.id)">
        <i class="material-icons-round">delete_sweep</i>
        <label>بله مطمئنم، حذف شود</label>
      </div>
      <div class="mbtn fRow jCenter aCenter mini" @click="deleteMode = false">
        <i class="material-icons-round">close</i>
        <label>انصراف</label>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Sw from '@/components/SwitchButton.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  props: ['data'],
  mixins: [errorHandler, makeToast],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // f
      status: true,
      state: true,
      slider: false,
      swLoad: false,
      deleteMode: false,
    };
  },
  components: {
    Sw,
  },
  methods: {
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    goToVideoUpload() {
      this.$store.commit('setVideoUploaderData', this.data);
      this.$router.push('/videoUpload');
    },
    // عوض کردن وضعیت
    updateStates(s) {
      this.swLoad = true;
      if (s === 'state') {
        this.state = !this.state;
        // alert(`set too state: ${this.state ? 1 : 2}`);
      } else if (s === 'status') {
        this.status = !this.status;
        // alert(`set too status: ${this.status}`);
      }
      axios({
        method: 'patch',
        // eslint-disable-next-line
        url: `${this.baseURL}/api/v${this.V}/Courses/${this.data.id}?status=${this.status}&state=${this.state ? 1 : 2}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        // data: {
        //   status: this.status,
        //   state: this.state ? 2 : 1,
        // },
      }).then(
        (response) => {
          this.swLoad = false;
          if (response.data.isSuccess) {
            if (this.teacherStatus) {
              this.makeToast('success', `${this.data.title} با موفقیت به روز رسانی شد`, 2000);
            } else {
              this.makeToast('success', `${this.data.title} با موفقیت به روز رسانی شد`, 2000);
            }
          } else {
            this.makeToast('error', `خطا در بروز رسانی وضعیت ${this.data.title}`, 2000);
          }
        },
        (error) => {
          this.swLoad = false;
          this.makeToast('error', this.errorHandler(error), 2000);
        },
      );
    },
    // عوض کردن اسلایدر
    changeSlider() {
      this.swLoad = true;
      axios({
        method: 'patch',
        url: `${this.baseURL}/api/v${this.V}/Courses/slider/${this.data.id}?isSlider=${!this.slider}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        // data: {
        //   isSlider: !this.slider,
        // },
      }).then(
        (response) => {
          if (response.data.isSuccess) {
            this.swLoad = false;
            this.slider = !this.slider;
            if (this.slider) {
              this.makeToast('success', 'دوره در اسلایدر نمایش داده خواهد شد', 2000);
            } else {
              this.makeToast('success', 'دوره از اسلایدر حذف شد', 2000);
            }
          } else {
            this.makeToast('error', 'خطا در بروز رسانی اسلایدر', 2000);
          }
        },
        (error) => {
          this.swLoad = false;
          this.makeToast('error', this.errorHandler(error), 2000);
        },
      );
    },
    goEdit() {
      this.$store.commit('setCourseEdit', this.data);
      this.$emit('edit');
    },
    deleteCourse() {
      axios({
        method: 'delete',
        url: `${this.baseURL}/api/v${this.V}/Courses/${this.data.id}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        // data: {
        //   isSlider: !this.slider,
        // },
      }).then(
        (response) => {
          if (response.data.isSuccess) {
            this.$emit('refresh');
            this.makeToast('error', `دورۀ ${this.data.title} با موفقیت حذف شد`, 2000);
          } else {
            this.makeToast('error', 'خطا در حذف دوره، دوباره تلاش کنید', 2000);
          }
        },
        (error) => {
          this.swLoad = false;
          this.makeToast('error', this.errorHandler(error), 2000);
        },
      );
    },
  },
  mounted() {
    this.status = this.data.status;
    if (this.data.state === 1) {
      this.state = true;
    } else if (this.data.state === 2) {
      this.state = false;
    }
    // alert(this.state);
    this.slider = this.data.isSlider;
  },
};
</script>

<style lang="scss" scoped>
.coursePreviewItem {
  padding: 8px 8px 8px 0;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  .cover {
    $photoSize: 142px;
    width: $photoSize;
    height: $photoSize;
    min-width: $photoSize;
    border-radius: 12px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin-left: 8px;
  }
  .infos {
    .first {
      .t {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 8px;
        text-align: right;
        padding-bottom: 8px;
        border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
        i {
          margin-left: 8px;
          font-size: 16px;
        }
      }
      .teacher {
        font-size: 10px;
        line-height: 1;
        .lesson {
          font-size: 10px;
          text-align: right;
          padding: 0 4px 4px 0;
          border-right: solid 2px rgba($color: #000000, $alpha: 0.05);
        }
        .grades {
          font-size: 10px;
          font-weight: 100;
          text-align: right;
          padding: 4px 4px 4px 0;
          border-right: solid 2px rgba($color: #000000, $alpha: 0.05);
        }
        .teacherName {
          font-weight: 500;
          font-size: 14px;
          text-align: right;
          padding: 4px 4px 8px 0;
          border-right: solid 2px rgba($color: #000000, $alpha: 0.05);
        }
        .av {
          $tas: 48px;
          width: $tas;
          height: $tas;
          min-width: $tas;
          border-radius: 64px;
          background-color: rgba($color: #000000, $alpha: 0.05);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          margin-left: 4px;
        }
      }
      .price {
        padding: 4px 8px;
        border-radius: 36px 8px 8px 36px;
        background-color: rgb(92, 194, 92);
        color: white;
        font-size: 14px;
        font-weight: bold;
        line-height: 1;
        border-right: solid 4px rgba($color: #258a36, $alpha: 0.5);
        .toman {
          line-height: 1;
          font-size: 10px;
          color: white;
          margin-right: 8px;
          font-weight: 200;
        }
      }
      .discount {
        padding: 4px 8px;
        border-radius: 36px 8px 8px 36px;
        background-color: rgb(216, 0, 0);
        color: white;
        font-size: 14px;
        font-weight: bold;
        line-height: 1;
        margin-top: 4px;
        border-right: solid 4px rgba($color: #f88d00, $alpha: 0.5);
        .toman {
          line-height: 1;
          font-size: 10px;
          color: white;
          font-weight: 200;
        }
      }
    }
    .seconds {
      margin-left: 16px;
      .infoItem {
        padding: 4px;
        margin: 4px 0;
        border-radius: 8px;
        background-color: rgba($color: #000000, $alpha: 0.05);
        i {
          font-size: 12px;
          color: rgba($color: #000000, $alpha: 0.5);
        }
        span {
          font-size: 10px;
          font-weight: bold;
        }
      }
      .infoItem.price {
        border: solid 2px rgba($color: rgb(45, 207, 45), $alpha: 1);
      }
      .infoItem.discount {
        border: solid 2px rgba($color: rgb(187, 15, 15), $alpha: 0.25);
      }
    }
  }
  .actionRow {
    border-radius: 0 64px 64px 0;
    padding: 16px;
    background-color: rgba($color: #000000, $alpha: 0.05);
    i.ac {
      padding: 8px;
      border-radius: 64px;
      transition: all ease-in-out 0.3s;
      cursor: pointer;
      font-size: 16px;
    }
    i.ac:hover {
      background-color: rgba($color: #000000, $alpha: 0.1);
    }
  }
}
.coursePreviewItem:nth-child(odd) {
  background-color: rgba($color: #000000, $alpha: 0.05);
}
  .deleteBox {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: red;
    z-index: 200;
    padding: 0 16px;
    i.del {
      font-size: 32px;
      color: white;
      text-shadow: 0 4px 0px rgba($color: #000000, $alpha: 0.25);
      margin-left: 16px;
    }
    .deleteQuestion {
      margin-left: 16px;
      .q {
        font-size: 16px;
        font-weight: bold;
        color: white;
      }
      .d {
        font-size: 12px;
        color: white;
      }
    }
    .dbtn {
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 16px;
      background-color: white;
      color: #000000;
      margin-left: 8px;
      * {
        pointer-events: none;
      }
      i {
        margin-left: 4px;
        font-size: 16px;
      }
      label {
        font-size: 14px;
      }
    }
    .mbtn {
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 16px;
      background-color: rgba(0, 0, 0, 0.082);
      color: #ffffff;
      * {
        pointer-events: none;
      }
      i {
        margin-left: 4px;
        font-size: 12px;
        color: white;
      }
      label {
        font-size: 12px;
        font-weight: bold;
        color: white;
      }
    }
  }
</style>
